import React, { useState, useEffect, useContext, useRef, useImperativeHandle } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Popover, Avatar, Divider, Grid, Button, Tooltip } from '@material-ui/core';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
//import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import { blue, grey, red } from '@material-ui/core/colors';
import IconButton from '@mui/material/IconButton';
import CommuteIcon from '@mui/icons-material/Commute';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
// import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
// import VideocamIcon from '@material-ui/icons/Videocam';
import DeviceIcon from '@material-ui/icons/DeviceHub';
// import LockIcon from '@material-ui/icons/Lock';
import HelpIcon from '@material-ui/icons/HelpOutline';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ListAltIcon from '@material-ui/icons/ListAlt';
// import LocationIcon from '@material-ui/icons/Room';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Extension from '@material-ui/icons/Extension';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import HomeIcon from '@material-ui/icons/Home';
import PersonTypeIcon from '@material-ui/icons/Accessibility';
import ReportIcon from '@material-ui/icons/Assessment';
import CasesIcon from '@material-ui/icons/Policy';
import CaseIcon from '@material-ui/icons/Gavel';
import CaseFileIcon from '@material-ui/icons/PermMedia';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import MapIcon from '@material-ui/icons/Map';
import InputIcon from '@material-ui/icons/Input';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import logo from '../assets/img/logo-horizontal.png';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ExportIcon from '@mui/icons-material/IosShare';
import DoorBackIcon from '@mui/icons-material/DoorBack';
import KeyboardIcon from '@material-ui/icons/Keyboard';
import ApiIcon from '@mui/icons-material/Api';
import SettingsIcon from '@material-ui/icons/Settings';
import MonitorIcon from '@mui/icons-material/Monitor';
import RouteIcon from '@mui/icons-material/Route';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import WebhookIcon from '@mui/icons-material/Webhook';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';


import Popup from "./Popup.js";
import SettingsModal from "./SettingsModal.js";

import { AuthContext } from '../providers/Auth';
import { ShortcutsContext } from '../providers/Shortcuts';

import storage from '../utils/storage';
import { PermissionsContext } from '../providers/Permissions';

import config from "../configs/config"
import api from "../services/api"

const drawerWidth = 350;
const drawerCollapsedWidth = 76;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create(['width', 'borderRadius'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    //borderRadius:  '0 20px 20px 0' 
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create(['width', 'borderRadius'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: drawerCollapsedWidth,
    [theme.breakpoints.up('sm')]: {
        width: drawerCollapsedWidth,
    },
    //borderRadius:  '0'
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    marginLeft: drawerCollapsedWidth,
    width: `calc(100% - ${drawerCollapsedWidth}px)`,
    height: 84,
    background: 'linear-gradient(180deg, rgba(8, 25, 39, 0.98) 0%, rgba(6, 19, 31, 1) 100%)',
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const audioUrl = config.useSsl ? (
    `https://${config.host}:${config.port}/midias/audios/danger_alert_2.mp3`
) : (
    `http://${config.host}:${config.port}/midias/audios/danger_alert_2.mp3`
)

const useAudio = url => {
    const [audio] = useState(new Audio(url));
    const [playing, setPlaying] = useState(false);

    const toggleAudio = () => setPlaying(!playing);

    const playAudio = () => setPlaying(true);

    const stopAudio = () => setPlaying(false);

    useEffect(() => {
        playing ? audio.play() : audio.pause();
    },
        [playing, audio]
    );

    useEffect(() => {
        audio.addEventListener('ended', () => {
            console.log("ended")
            if (!playing) {
                console.log("play again")
                audio.play()
            } else {
                console.log("stop play")
                setPlaying(false)
            }
        });
        return () => {
            audio.addEventListener('ended', () => {
                console.log("ended")
                if (!playing) {
                    console.log("play again")
                    audio.play()
                } else {
                    console.log("stop play")
                    setPlaying(false)
                }
            });
        };
    }, []);

    return [playing, toggleAudio, playAudio, stopAudio];
};


const SideMenu = React.forwardRef(() => {
    const theme = useTheme();
    const location = useLocation();
    const [isOpen, setIsOpen] = React.useState(false);

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
    } = useContext(PermissionsContext);

    const [openSettings, setOpenSettings] = useState(false);
    const toggleSettings = () => setOpenSettings(!openSettings);

    const classes = useStyles();
    const menuRef = useRef(null);

    const { storeSystemShortcut, invalidateSystemShortcut } = useContext(ShortcutsContext);

    useEffect(() => {
        storeSystemShortcut({
            referrer: 'MENU',
            callback: () => {
                menuRef.current?.toggle();
            }
        });

        return () => invalidateSystemShortcut('MENU')
    }, [invalidateSystemShortcut, storeSystemShortcut]);

    useImperativeHandle(menuRef, () => ({
        toggle() {
            setIsOpen(!isOpen)
        }
    }));

    const [display, setDisplay] = useState(false);
    const [reportDisplay, setReportDisplay] = useState(false);
    const [caseDisplay, setCaseDisplay] = useState(false);
    const [vehicleDisplay, setVehicleDisplay] = useState(false);
    const [deviceDisplay, setDeviceDisplay] = useState(false);
    const [notificationDisplay, setNotificationDisplay] = useState(false);
    const [displayArrow, setDisplayArrow] = useState(false);
    const [authenticated, setAuthenticated] = useState(null);

    useEffect(() => {
        const user = storage.getItem('@Identifik:user');

        setAuthenticated(user);
    }, []);

    const handleDrawerOpen = () => {
        setIsOpen(true);
    };
    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    }

    const handleDrawerClose = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (isOpen) {
            setDisplayArrow(true)
        } else {
            setDisplayArrow(false)
            setDisplay(false)
            setVehicleDisplay(false)
            setDeviceDisplay(false)
            setReportDisplay(false)
            setCaseDisplay(false)
            setNotificationDisplay(false)
        }
    }, [isOpen])

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const auth = useContext(AuthContext);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const signOut = () => auth.signOut();

    const firstLetterName = () => {
        const { name } = storage.getItem('@Identifik:user');

        return name.charAt(0);
    };

    const openUserTree = () => {
        handleDrawerOpen();
        setDisplay(!display);
    }

    const toggleFocus = () => setDisplay(true);
    const toggleBlur = () => setDisplay(false);

    const openVehicleTree = () => {
        handleDrawerOpen();
        setVehicleDisplay(!vehicleDisplay);
    }

    const vehicleToggleFocus = () => setVehicleDisplay(true);
    const vehicleToggleBlur = () => setVehicleDisplay(false);

    const openDevicesTree = () => {
        handleDrawerOpen();
        setDeviceDisplay(!deviceDisplay);
    }

    const devicesToggleFocus = () => setDeviceDisplay(true);
    const devicesToggleBlur = () => setDeviceDisplay(false);


    const openReportTree = () => {
        handleDrawerOpen();
        setReportDisplay(!reportDisplay);
    }

    const reportToggleFocus = () => setReportDisplay(true);
    const reportToggleBlur = () => setReportDisplay(false);

    const openCaseTree = () => {
        handleDrawerOpen();
        setCaseDisplay(!caseDisplay);
    }

    const caseToggleFocus = () => setCaseDisplay(true);
    const caseToggleBlur = () => setCaseDisplay(false);

    const openNotificationTree = () => {
        handleDrawerOpen();
        setNotificationDisplay(!notificationDisplay);
    }

    const notificationToggleFocus = () => setNotificationDisplay(true);
    const notificationToggleBlur = () => setNotificationDisplay(false);

    const [openDangerAlert, setOpenDangerAlert] = useState(false);
    const [playing, toggle, playAudio, stopAudio] = useAudio(audioUrl);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const createLog = async (starting) => {
        try {
            const data = {
                name: starting ? "Botão Pânico Iniciado - " + Date.now() : "Botão Pânico Parado - " + Date.now(),
                description: starting ? "Botão Pânico Iniciado" : "Botão Pânico Parado",
                case_type_id: null,
                files: [],
            };


            await api.post('/case/create', data);
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const isActiveRoute = (routes) => {
        if (!Array.isArray(routes)) {
            return location.pathname === routes;
        }

        return routes.some((route) => location.pathname === route || location.pathname.startsWith(`${route}/`));
    };

    const menuItem = (title, content) => (
        <Tooltip title={isOpen ? '' : title} placement="right" arrow enterDelay={250}>
            <span style={{ display: 'block', width: '100%' }}>{content}</span>
        </Tooltip>
    );

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" open={isOpen}>
            <Toolbar style={{ background: 'transparent', minHeight: 84, height: 84, paddingTop: 0, paddingBottom: 0, }} >
                    
                    <div className={classes.logoContainer}>
                        <img src={logo} alt="logo" className={classes.logo} />
                    </div>
                    <div>
                        <PermissionOneOfWrapper routes={[
                            "/security_alert/start",
                            "/security_alert/stop",
                        ]}>
                            <IconButton
                                edge="end"
                                aria-label="user options"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                // color="secondary"
                                onClick={() => {
                                    setOpenDangerAlert(true)
                                }}
                                // className={classes.danger_alert}
                                style={{
                                    color: "#fff",
                                    backgroundColor: red[700],
                                    marginRight: 4,
                                }}
                            >
                                <GppMaybeIcon />
                            </IconButton>
                            <Popup
                                openPopup={openDangerAlert}
                                setOpenPopup={setOpenDangerAlert}
                                title="Alerta de Segurança"
                            >
                                <Grid container spacing={3} justify='center' alignItems='center'>
                                    <PermissionWrapper route="/security_alert/start">
                                        <Grid item xs={12}>
                                            <Button
                                                variant='contained'
                                                color="secondary"
                                                fullWidth={true}
                                                onClick={async () => {
                                                    playAudio();
                                                    await createLog(true);
                                                }}
                                            >
                                                Disparar
                                            </Button>
                                        </Grid>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/security_alert/stop">
                                        <Grid item xs={12}>
                                            <Button
                                                variant='contained'
                                                color="primary"
                                                fullWidth={true}
                                                onClick={async () => {
                                                    stopAudio();
                                                    await createLog(false);
                                                }}
                                            >
                                                Parar
                                            </Button>
                                        </Grid>
                                    </PermissionWrapper>
                                </Grid>
                            </Popup>
                        </PermissionOneOfWrapper>
                        <IconButton
                            edge="end"
                            aria-label="user options"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            color="inherit"
                            onClick={handleMenu}
                        >
                            <Avatar className={classes.avatar}>
                                {firstLetterName()}
                            </Avatar>
                        </IconButton>
                        <Popover
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            open={open}
                            onClose={handleClose}
                            keepMounted
                        >
                            {
                                (authenticated && authenticated?.id === 1 && authenticated?.role === "admin") && (
                                    <div onClick={toggleSettings} className={classes.popoverItem}>
                                        Configurações <SettingsIcon />
                                    </div>
                                )
                            }
                            <Divider />
                            <div onClick={signOut} className={classes.popoverItem}>
                                Sair <ExitToAppIcon />
                            </div>
                        </Popover>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={isOpen} className={classes.drawer} style={{ background: 'transparent', color: '#C5CAE9', border: 'none' }}>
                <DrawerHeader
                    style={{
                        background: 'linear-gradient(180deg, rgba(8, 25, 39, 0.98) 0%, rgba(6, 19, 31, 1) 100%)',
                        border: 'none',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 12,
                        minHeight: 84,
                        padding: '14px 12px 14px 16px',
                        borderBottom: '1px solid rgba(197, 202, 233, 0.08)',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, flex: 1, justifyContent: isOpen && 'space-between' }}>
                        
                        {/*<div
                            className={classes.logoContainer}
                            style={{
                                display: isOpen ? 'flex' : 'none',
                                alignItems: 'center',
                                minWidth: 0,
                            }}
                        >
                            <img src={logo} alt="logo" className={classes.logo} />
                        </div>*/}
                        <div
                            style={{
                                display: isOpen ? 'flex' : 'none',
                                flexDirection: 'column',
                                minWidth: 0,
                                marginLeft: 4,
                            }}
                        >
                            <h3 style={{ color: '#F3F6FF', margin: 0, fontWeight: 600, letterSpacing: '0.04em', fontSize: 16, lineHeight: 1.1 }}>Menu</h3>
                            <span style={{ color: 'rgba(197, 202, 233, 0.72)', fontSize: 12, marginTop: 3, whiteSpace: 'nowrap' }}>Navegação principal</span>
                        </div>
                        
                            <Tooltip title={isOpen ? 'Fechar menu' : 'Abrir menu'} placement="right" arrow enterDelay={250} sx={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
                                <IconButton onClick={toggleDrawer} style={{ color: '#C5CAE9' }}>
                                    {isOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                                </IconButton>
                            </Tooltip>
                        
                    </div>
                   
                </DrawerHeader>
                <div className={classes.drawerContainer} style={{ border: 'none' }}>
                    <List>
                        <PermissionWrapper route="/dashboard">
                            {menuItem('Dashboard',
                            <div className={classes.listItemContainer}>
                                <ListItem
                                    onFocus={handleDrawerOpen}
                                    className={classes.linkFocus}
                                    button
                                    selected={isActiveRoute('/dashboard')}
                                    component={Link}
                                    to="/dashboard"
                                    style={{ background: 'transparent' }}
                                    id="dashboard"
                                    name="dashboard"
                                >
                                    <ListItemIcon><DashboardIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                    <ListItemText primary="Dashboard" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                </ListItem>
                            </div>
                            )}
                        </PermissionWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/pessoa",
                            "/tipo_de_pessoa",
                            "/custom_input",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Pessoas'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        selected={isActiveRoute(['/pessoa', '/tipo_de_pessoa', '/custom_input', '/tela_de_usuario_customizado'])}
                                        component={ListItemButton}
                                        onClick={() => {
                                            openUserTree();
                                        }}
                                        onFocus={toggleBlur}
                                
                                        id="pessoas"
                                    >
                                        <ListItemIcon ><PeopleIcon style={{ color: 'rgb(197, 202, 233)' }} /></ListItemIcon>
                                        <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Pessoas" />
                                        <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }} id="pessoas">{display ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                    </ListItem>
                                </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ paddingTop: display ? '8px' : '0px', paddingBottom: display ? '8px' : '0px', maxWidth: display ? '300px' : '0px', maxHeight: display ? '300px' : '0px', transition: 'max-height .35s ease, max-width .35s ease, padding .35s ease, opacity .35s ease', overflow: 'hidden', opacity: display ? 1 : 0 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <PermissionWrapper route="/pessoa">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={toggleFocus} className={classes.linkFocus} button selected={isActiveRoute('/pessoa')} component={Link} to="/pessoa" id="criar_pessoa">
                                                <ListItemIcon><PeopleIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Listar pessoas" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/tela_de_usuario_customizado">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={toggleFocus} className={classes.linkFocus} button selected={isActiveRoute('/tela_de_usuario_customizado')} component={Link} to="/tela_de_usuario_customizado" style={{ background: 'transparent' }} id="simplified_registration">
                                                <ListItemIcon ><PersonTypeIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Visitante básico" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/tipo_de_pessoa">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={toggleFocus} className={classes.linkFocus} button selected={isActiveRoute('/tipo_de_pessoa')} component={Link} to="/tipo_de_pessoa" style={{ background: 'transparent' }} id="tipo_de_pessoa">
                                                <ListItemIcon ><PersonTypeIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Tipo de Pessoas" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>

                                    <PermissionWrapper route="/custom_input">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={toggleFocus} className={classes.linkFocus} button selected={isActiveRoute('/custom_input')} component={Link} to="/custom_input" id="campo_personalizado">
                                                <ListItemIcon ><InputIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Campos Personalizados" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/veiculos",
                            "/tipo_de_veiculo",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Veículos'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        selected={isActiveRoute(['/veiculos', '/tipo_de_veiculo'])}
                                        component={ListItemButton}
                                        onClick={() => {
                                            openVehicleTree();
                                        }}
                                        onFocus={vehicleToggleBlur}
                                        style={{ background: 'transparent' }}
                                        id="veiculos"
                                    >
                                        <ListItemIcon ><CommuteIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Veiculos" />
                                        <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }} id="veiculos">{vehicleDisplay ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                    </ListItem>
                                </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ background: 'transparent', paddingTop: vehicleDisplay ? '8px' : '0px', paddingBottom: vehicleDisplay ? '8px' : '0px', maxWidth: vehicleDisplay ? '300px' : '0px', maxHeight: vehicleDisplay ? '300px' : '0px', transition: 'max-height .35s ease, max-width .35s ease, padding .35s ease, opacity .35s ease', overflow: 'hidden', opacity: vehicleDisplay ? 1 : 0 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <PermissionWrapper route="/veiculos">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={vehicleToggleBlur} className={classes.linkFocus} button selected={isActiveRoute('/veiculos')} component={Link} to="/veiculos" id="criar_veiculo">
                                                <ListItemIcon><DirectionsCarIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Listar veículos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/tipo_de_veiculo">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={vehicleToggleFocus} className={classes.linkFocus} button selected={isActiveRoute('/tipo_de_veiculo')} component={Link} to="/tipo_de_veiculo" id="tipo_veiculo">
                                                <ListItemIcon ><CarRepairIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Tipo de Veículos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/dispositivo",
                            "/listar_cameras",
                            "/timeline_recorder",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Dispositivos'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        component={ListItemButton}
                                        selected={isActiveRoute(['/dispositivo', '/listar_cameras', '/timeline_recorder'])}
                                        onClick={() => {
                                        openDevicesTree();
                                        
                                    }}
                                    onFocus={devicesToggleBlur}
                                    style={{ background: 'transparent' }}
                                    id="devices"
                                >
                                    <ListItemIcon ><DeviceIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                    <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Dispositivos" />
                                    <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }} id="devices">{deviceDisplay ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                </ListItem>
                            </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ background: 'transparent', paddingTop: deviceDisplay ? '8px' : '0px', paddingBottom: deviceDisplay ? '8px' : '0px', maxWidth: deviceDisplay ? '300px' : '0px', maxHeight: deviceDisplay ? '300px' : '0px', transition: 'max-height .5s ease-in-out, max-width .5s, padding .5s', overflow: 'hidden' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <PermissionWrapper route="/dispositivo">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={devicesToggleBlur} className={classes.linkFocus} button component={Link} to="/dispositivo" style={{ background: 'transparent' }} id="dispositivo"
                                            selected={isActiveRoute('/dispositivo')}>
                                                <ListItemIcon ><AccountTreeOutlinedIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Listar Dispositivos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/listar_cameras">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={devicesToggleFocus} className={classes.linkFocus} button component={Link} to="/listar_cameras" id="listar_cameras"
                                            selected={isActiveRoute('/listar_cameras')}>
                                                <ListItemIcon ><VideoCameraBackOutlinedIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Listar Cameras" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>

                                    <PermissionWrapper route="/timeline_recorder">
                                        <div className={classes.listItemContainer}>
                                            <ListItem onFocus={devicesToggleFocus} className={classes.linkFocus} button component={Link} to="/timeline_recorder" id="timeline_recorder"
                                            selected={isActiveRoute('/timeline_recorder')}>
                                                <ListItemIcon ><VideoLibraryIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Timeline Recorder" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>

                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionWrapper route="/controle_remoto">
                            <Tooltip title={isOpen ? '' : 'Registros de Controle'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/controle_remoto" style={{ background: 'transparent' }} id="tipo_de_pessoa"
                                    selected={isActiveRoute('/controle_remoto')}>
                                        <ListItemIcon ><DoorBackIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Registros de Controle" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/operações">
                            <Tooltip title={isOpen ? '' : 'Registros de Operação'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/operações" style={{ background: 'transparent' }} id="tipo_de_pessoa"
                                    selected={isActiveRoute('/operações')}>
                                        <ListItemIcon ><AssignmentIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Registros de Operação" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        
                        </PermissionWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/casos",
                            "/caso/tipos",
                            "/evidencias",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Ocorrências'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        component={ListItemButton}
                                        onClick={() => {
                                            openCaseTree();
                                        }}
                                        onFocus={caseToggleBlur}
                                        style={{ background: 'transparent' }}
                                        id="ocorrencias-container"
                                        selected={isActiveRoute(['/casos', '/caso/tipos', '/evidencias'])}
                                    >
                                        <ListItemIcon ><CasesIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Ocorrências" />
                                        <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }} id="ocorrencias">{caseDisplay ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                    </ListItem>
                                </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ background: 'transparent', paddingTop: caseDisplay ? '8px' : '0px', paddingBottom: caseDisplay ? '8px' : '0px', maxWidth: caseDisplay ? '300px' : '0px', maxHeight: caseDisplay ? '300px' : '0px', transition: 'max-height .5s ease-in-out, max-width .5s, padding .5s', overflow: 'hidden' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <PermissionWrapper route="/casos">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={caseToggleFocus} className={classes.linkFocus} button component={Link} to="/casos" id="casos" selected={isActiveRoute('/casos')}>
                                                <ListItemIcon ><CaseIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Casos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/caso/tipos">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={caseToggleFocus} className={classes.linkFocus} button component={Link} to="/caso/tipos" id="tipos-casos" selected={isActiveRoute('/caso/tipos')}>
                                                <ListItemIcon ><ListAltIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Tipos de Casos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/evidencias">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={caseToggleFocus} className={classes.linkFocus} button component={Link} to="/evidencias" id="evidencias" selected={isActiveRoute('/evidencias')}>
                                                <ListItemIcon><CaseFileIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Evidências" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionWrapper route="/grupos_de_dispositivos">
                            <Tooltip title={isOpen ? '' : 'Grupos de Dispositivos'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/grupos_de_dispositivos" style={{ background: 'transparent' }} id="tipo_de_pessoa"
                                    selected={isActiveRoute('/grupos_de_dispositivos')}>
                                        <ListItemIcon ><ApiIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Grupos de Dispositivos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        {/* <ListItem button component={Link} to="/camera/acessos" style={{background: '#06131f'}} id="acessos_camera">
                            <ListItemIcon ><VideocamIcon style={{color: '#C5CAE9'}}/></ListItemIcon>
                            <ListItemText primary="Acessos (câmera)" style={{color: '#C5CAE9'}}/>
                        </ListItem>
                        <ListItem button component={Link} to="/colaborador/acessos" style={{background: '#06131f'}} id="acessos_colaborador">
                            <ListItemIcon ><MeetingRoomIcon style={{color: '#C5CAE9'}}/></ListItemIcon>
                            <ListItemText primary="Acessos (facial)" style={{color: '#C5CAE9'}}/>
                        </ListItem>
                        <ListItem button component={Link} to="/catracas/acessos" style={{background: '#06131f'}} id="acessos_catraca">
                            <ListItemIcon ><LockIcon style={{color: '#C5CAE9'}}/></ListItemIcon>
                            <ListItemText primary="Acessos (catraca)" style={{color: '#C5CAE9'}}/>
                        </ListItem> */}
                        {/* <ListItem className={classes.listItem} button component={Link} to="/localizar">
                        <ListItemIcon className={classes.icon}><LocationIcon style={{color: '#C5CAE9'}}/></ListItemIcon>
                        <ListItemText className={classes.itemText} primary="Localização" style={{color: '#C5CAE9'}}/>
                    </ListItem> */}

                        <PermissionWrapper route="/paineis">
                            <Tooltip title={isOpen ? '' : 'Paineis de Segurança'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/paineis" style={{ background: 'transparent' }} id="tipo_de_pessoa" selected={isActiveRoute('/paineis')}>
                                        <ListItemIcon ><MonitorIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Paineis de Segurança" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/relatorio_unificado",
                            "/relatorio_veiculos",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Relatórios'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        component={ListItemButton}
                                        onClick={() => {
                                            openReportTree();
                                        }}
                                        onFocus={reportToggleBlur}
                                        style={{ background: 'transparent' }}
                                        id="relatorios"
                                        selected={isActiveRoute(['/relatorio_unificado', '/relatorio_veiculos'])}
                                    >
                                        <ListItemIcon ><ReportIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Relatorios" />
                                        <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }} id="relatorios">{reportDisplay ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                    </ListItem>
                                </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ background: 'transparent', paddingTop: reportDisplay ? '8px' : '0px', paddingBottom: reportDisplay ? '8px' : '0px', maxWidth: reportDisplay ? '300px' : '0px', maxHeight: reportDisplay ? '300px' : '0px', transition: 'max-height .5s ease-in-out, max-width .5s, padding .5s', overflow: 'hidden' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <PermissionWrapper route="/relatorio_unificado">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={reportToggleFocus} className={classes.linkFocus} button component={Link} to="/relatorio_unificado" id="pessoas"
                                            selected={isActiveRoute('/relatorio_unificado')}>
                                                <ListItemIcon ><PeopleIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Pessoas" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/relatorio_veiculos">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={reportToggleFocus} className={classes.linkFocus} button component={Link} to="/relatorio_veiculos" id="veiculo"
                                            selected={isActiveRoute('/relatorio_veiculos')}>
                                                <ListItemIcon><DirectionsCarIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Veículos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionWrapper route="/exportar_pessoas">
                            <Tooltip title={isOpen ? '' : 'Exportar Pessoas'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/exportar_pessoas" style={{ background: 'transparent' }} id="exportar_pessoas" selected={isActiveRoute('/exportar_pessoas')}>
                                        <ListItemIcon ><ExportIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Exportar Pessoas" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/organizational">
                            <Tooltip title={isOpen ? '' : 'Organização'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/organizational" style={{ background: 'transparent' }} id="organizational" selected={isActiveRoute('/organizational')}>
                                        <ListItemIcon ><AccountTreeIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Organização" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/credenciais">
                            <Tooltip title={isOpen ? '' : 'Credenciais'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/credenciais" style={{ background: 'transparent' }} id="credenciais" selected={isActiveRoute('/credenciais')}>
                                        <ListItemIcon ><CreditCardIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Credenciais" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/perfil_de_acesso">
                            <Tooltip title={isOpen ? '' : 'Perfis de Acesso'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/perfil_de_acesso" style={{ background: 'transparent' }} id="perfil_de_acesso" selected={isActiveRoute('/perfil_de_acesso')}>
                                        <ListItemIcon ><AssignmentIndIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Perfis de acesso" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/funcionalidades">
                            <Tooltip title={isOpen ? '' : 'Funcionalidades'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/funcionalidades" style={{ background: 'transparent' }} id="lista_funcionalidade" selected={isActiveRoute('/funcionalidades')}>
                                        <ListItemIcon ><Extension style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Funcionalidades" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/rotas_de_api">
                            <Tooltip title={isOpen ? '' : 'Rotas de API'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/rotas_de_api" style={{ background: 'transparent' }} id="lista_funcionalidade" selected={isActiveRoute('/rotas_de_api')}>
                                        <ListItemIcon ><RouteIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Rotas de API" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/local">
                            <Tooltip title={isOpen ? '' : 'Locais'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/local" style={{ background: 'transparent' }} id="local" selected={isActiveRoute('/local')}>
                                        <ListItemIcon ><HomeIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Locais" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/mapa">
                            <Tooltip title={isOpen ? '' : 'Mapas'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/mapa" style={{ background: 'transparent' }} id="mapa" selected={isActiveRoute('/mapa')}>
                                        <ListItemIcon ><MapIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Mapas" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionOneOfWrapper routes={[
                            "/notificação",
                            "/notificações_de_ausência",
                        ]}>
                            <Tooltip title={isOpen ? '' : 'Notificações'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem
                                        className={classes.linkFocus}
                                        button
                                        component={ListItemButton}
                                        selected={isActiveRoute('/notificação') || isActiveRoute('/notificações_de_ausência')}
                                        onClick={() => {
                                        openNotificationTree();
                                    }}
                                    onFocus={notificationToggleBlur}
                                    style={{ background: 'transparent' }}
                                    id="notificacoes"
                                >
                                    <ListItemIcon ><NotificationsIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                    <ListItemText style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} primary="Notificações" />
                                    <ListItemIcon style={{ color: '#C5CAE9', display: displayArrow ? 'block' : 'none', paddingLeft: '35px' }}>{notificationDisplay ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ListItemIcon>
                                </ListItem>
                            </div>
                            </Tooltip>
                            <ListItem className={classes.submenuShell} style={{ background: 'transparent', paddingTop: notificationDisplay ? '8px' : '0px', paddingBottom: notificationDisplay ? '8px' : '0px', maxWidth: notificationDisplay ? '300px' : '0px', maxHeight: notificationDisplay ? '300px' : '0px', transition: 'max-height .5s ease-in-out, max-width .5s, padding .5s', overflow: 'hidden' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <PermissionWrapper route="/notificação">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={notificationToggleFocus} className={classes.linkFocus} button component={Link} to="/notificação" selected={isActiveRoute('/notificação')}>
                                                <ListItemIcon ><NotificationImportantIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Notificações de Acesso" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                    <PermissionWrapper route="/notificações_de_ausência">
                                        <div className={classes.listItemContainer}>
                                            <ListItem on onFocus={notificationToggleFocus} className={classes.linkFocus} button component={Link} to="/notificações_de_ausência" selected={isActiveRoute('/notificações_de_ausência')}>
                                                <ListItemIcon><NotificationsActiveIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                                <ListItemText primary="Notificações de Ausência" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                            </ListItem>
                                        </div>
                                    </PermissionWrapper>
                                </div>
                            </ListItem>
                        </PermissionOneOfWrapper>

                        <PermissionWrapper route="/webhooks">
                            <Tooltip title={isOpen ? '' : 'Webhooks'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/webhooks" style={{ background: 'transparent' }} id="ajuda" selected={isActiveRoute('/webhooks')}>
                                        <ListItemIcon ><WebhookIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Webhooks" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/atalhos">
                            <Tooltip title={isOpen ? '' : 'Atalhos'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/atalhos" style={{ background: 'transparent' }} id="ajuda" selected={isActiveRoute('/atalhos')}>
                                        <ListItemIcon ><KeyboardIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Atalhos" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>

                        <PermissionWrapper route="/ajuda">
                            <Tooltip title={isOpen ? '' : 'Ajuda'} placement="right" arrow enterDelay={250}>
                                <div className={classes.listItemContainer}>
                                    <ListItem className={classes.linkFocus} button component={Link} to="/ajuda" style={{ background: 'transparent' }} id="ajuda" selected={isActiveRoute('/ajuda')}>
                                        <ListItemIcon ><HelpIcon style={{ color: '#C5CAE9' }} /></ListItemIcon>
                                        <ListItemText primary="Ajuda" style={{ color: '#C5CAE9', opacity: isOpen ? 1 : 0, width: isOpen ? 'auto' : 0, margin: 0, whiteSpace: 'nowrap' }} />
                                    </ListItem>
                                </div>
                            </Tooltip>
                        </PermissionWrapper>
                    </List>
                </div>
            </Drawer>
            <Popup
                openPopup={openSettings}
                setOpenPopup={setOpenSettings}
                title="Configurações"
                width="70%"
            >
                <SettingsModal />
            </Popup>
        </Box>
    );
})

const useStyles = makeStyles(theme => ({
    drawer: {
        // width: metrics.drawerWidth,
        height: '100%',
        background: 'linear-gradient(180deg, #06131f 0%, #071824 45%, #081b29 100%)',
        flexShrink: 0,
        color: '#06131f',
        '& > div': {
            border: 'none',
            background: 'transparent'
            
        }

        
    },
    drawerPaper: {
        // width: metrics.drawerWidth,
        minWidth: '1rem',
        background: 'linear-gradient(180deg, #06131f 0%, #081624 100%)',
        padding: '0',
        color: '#C5CAE9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        transition: theme.transitions.create(
            ['width', 'display'],
            { duration: theme.transitions.easing.easeInOut }
        ),
    },
    drawerContainer: {
        height: '100%',
        background: 'linear-gradient(180deg, #06131f 0%, #081624 100%)',
        overflow: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#6c7888',
            outline: '1px solid slategrey',
            borderRadius: '12px',
            '&:hover': {
                cursor: 'pointer',
            }
        }
    },
    list: {

    },
    listItem: {
        '&:hover': {
            background: '#303F9F',
            '& $drawerPaper': {
                color: '#E8EAF6',
            },
            '& $icon': {
                color: '#E8EAF6',
            }
        }
    },
    icon: {
        display: 'flex',
        justifyContent: 'center',
        color: '#C5CAE9'
    },
    itemText: {
        display: 'none',
        fontWeight: 'bold',

    },
    logoContainer: {
        flexGrow: 1,
    },
    logo: {
        width: 180,
        verticalAlign: 'middle',
    },
    avatar: {
        color: theme.palette.getContrastText(blue[700]),
        backgroundColor: blue[700],
    },
    danger_alert: {
        color: theme.palette.getContrastText(red[700]),
        backgroundColor: red[700],
    },
    popoverItem: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'uppercase',
        fontWeight: 500,
        color: grey[700],
        padding: theme.spacing(1, 2),
        '& > *': {
            marginLeft: theme.spacing(1),
        },
        '&:hover': {
            backgroundColor: grey[100],
            textDecoration: 'none',
            cursor: 'pointer',
        },
    },
    linkFocus: {
        background: 'transparent',
        margin: '4px 10px',
        borderRadius: 12,
        minHeight: 46,
        '& .MuiListItemIcon-root': {
            minWidth: 42,
            color: '#C5CAE9',
        },
        '& .MuiListItemText-primary': {
            color: '#E8ECFF',
            fontWeight: 500,
            letterSpacing: '0.01em',
        },
        
        '&.Mui-selected': {
            background: 'rgba(87, 166, 255, 0.16)',
            boxShadow: 'inset 3px 0 0 #57A6FF, 0 8px 18px rgba(0,0,0,0.16)',
        },
        '&.Mui-selected:hover': {
            background: 'rgba(87, 166, 255, 0.22)',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 2px rgba(87, 166, 255, 0.28)',
        },
        '&:active': {
            border: "none"
        },
        
    },
    submenuShell: {
        margin: '4px 10px',
        borderLeft: '1px solid rgba(197, 202, 233, 0.16)',
        paddingLeft: 8,
        borderRadius: 12,
        
    },
    listItemContainer: {
        overflow: 'hidden',
        borderRadius: 12,
        margin: '4px 10px',
        transition: 'transform 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease',
        minHeight: 46,
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.06)',
            transform: 'translateX(4px)',
        },
        '&.Mui-selected': {
            background: 'rgba(87, 166, 255, 0.16)',
        },
        '&.Mui-selected:hover': {
            background: 'rgba(87, 166, 255, 0.22)',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 2px rgba(87, 166, 255, 0.28)',
        },
        '&:active': {
            border: "none"
        },
    },
}));

export default SideMenu;
